import { all } from 'redux-saga/effects'
import { _updateGeneralData, _updateLoginStatus, _updateProfileStatus, _updateRefreshToken, _updateSignupProgress, _updateNotificationCount } from './saga';

export default function* rootSaga() {
    yield all([_updateLoginStatus, _updateProfileStatus, _updateRefreshToken, _updateSignupProgress, _updateGeneralData, _updateNotificationCount]);

}